export default __webpack_public_path__ + "static/dev-visalia-41a771ae5ae9414bdc7e97be17011cfc.jpg";